import React from 'react';
import renderHTML from 'react-render-html';

class Tooltip extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tooltipHidden: true
		};
	}

	handleMouseEnter() {
		this.setState({
			tooltipHidden: false
		});
	}

	handleMouseLeave() {
		this.setState({
			tooltipHidden: true
		});
	}

	render() {
		return (
			<span
				className="tooltip"
				onMouseEnter={ () => this.handleMouseEnter() }
				onMouseLeave={ () => this.handleMouseLeave() }
			>
				{ this.props.trigger }
				<span
					className="tooltip-content"
					role="tooltip"
					aria-hidden={ this.state.tooltipHidden }
				>
					{ renderHTML(this.props.content) }
				</span>
			</span>
		);
	}
};

export default Tooltip;


// WEBPACK FOOTER //
// ./src/pages/common/Tooltip.js